function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.5 4H9a2 2 0 00-2-2H2V.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v19a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V12h5a2 2 0 002 2h6.5a.5.5 0 00.5-.5v-9a.5.5 0 00-.5-.5zM14 6v2H9V6h5zM7 6V4H2v2h5zm-5 4V8h5v2H2zm7 0v2h5v-2H9z"
});

var SvgFlag = function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 15 20",
    fill: "#D6D7E1"
  }, props), _ref);
};

export default SvgFlag;